import './App.css';
import Registration from './components/Registration';

function App() {
  return (
    <div>
      <Registration />
     
    </div>
  );
}

export default App;
